import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import useNotify from "./useNotify";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const UploadImage = ({ ...props }) => {
  const { uploadName, uploadApi, onSuccess, onError } = props;
  const showFileList = props?.showFileList ?? true;
  const { successNotify, errorNotify } = useNotify();
  const [filelist, setFilelist] = React.useState<any[]>([]);
  const [isUploading, setIsUploading] = React.useState(0);
  const handleFileChange = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      return;
    }

    let fileAize = file.size / 1024;
    if (fileAize > 1024) {
      errorNotify("File size should be less than 1MB");
      return false;
    }
    let fileNameType = file.name.split(".").pop();
    let fileType = ["jpg", "jpeg", "png"];
    if (fileType.indexOf(fileNameType) == -1) {
      errorNotify(
        "File type should be pdf, jpg, jpeg, png, doc, docx, xls, xlsx"
      );
      return false;
    }
    let fileName = file.name;
    if (file) {
      const formData = new FormData();
      formData.append(uploadName, file);

      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");
      setIsUploading(1);
      fetch(`${import.meta.env.VITE_API_URL}/` + uploadApi, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "X-CSRF-TOKEN": `${csrfToken}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data?.code == 200) {
            successNotify("File uploaded successfully");
            setFilelist((prev) => [...prev, data?.file]);
            if (props?.onSuccess) {
              props?.onSuccess(data?.file);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setIsUploading(0);
    }
  };

  return (
    <>
      {filelist.length > 0 && showFileList == true && (
        <Box>
          {filelist.map((item) => (
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Uploaded Files:
              {item}
            </Typography>
          ))}
        </Box>
      )}
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
        sx={{ width: "100%", maxWidth: "500px", mt: 1 }}
        disabled={props?.disabled ? true : false}
      >
        <VisuallyHiddenInput
          type="file"
          id={uploadName}
          name={uploadName}
          onChange={handleFileChange}
          disabled={isUploading}
        />
      </Button>
    </>
  );
};

export default UploadImage;
